import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Snackbar,
  Alert,
  CircularProgress, // Import CircularProgress
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import axios from "axios";

const  KullaniciTanimla = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [ad, setAd] = useState("");
  const [soyad, setSoyad] = useState("");
  const [kullaniciAdi, setKullaniciAdi] = useState("");
  const [sifre, setSifre] = useState("");
  const [aktifDurum, setAktifDurum] = useState(1);
  const [kullaniciRol, setKullaniciRol] = useState(1);
  const [error] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [loading, setLoading] = useState(false); // Loading state

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSubmit = async () => {
    setLoading(true); // Start loading
    try {
      const response = await axios.post("http://localhost:5001/api/v1/user/register", {
        kullanici_ad: ad,
        kullanici_soyad: soyad,
        username: kullaniciAdi,
        pass: sifre,
        aktif_durum_kd: aktifDurum,
        kullanici_rol_kd: aktifDurum,
      });
      console.log(response.data);
      setAd("");
      setSoyad("");
      setKullaniciAdi("");
      setSifre("");
      setAktifDurum(1);

      setSnackbarMessage("Kullanıcı başarıyla kaydedildi!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.log(error);
      setSnackbarMessage("Kullanıcı kaydedilirken bir hata oluştu.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: "50%",
        marginLeft: "10px",
        alignItems: "flex-start",
        border: "1px solid #ccc", // Add border
        borderRadius: "10px", // Optional: Add border radius
        padding: "20px", // Optional: Add padding inside the border
      }}
    >
      <Typography variant="h6" sx={{ marginBottom: 2 }}>
        Kullanıcı Bilgileri
      </Typography>
      <Box
        sx={{ display: "flex", flexDirection: "row", gap: 2, width: "100%" }}
      >
        <TextField
          label="Adı"
          variant="outlined"
          sx={{ flex: 1 }}
          value={ad}
          onChange={(e) => setAd(e.target.value)}
        />
        <TextField
          label="Soyadı"
          variant="outlined"
          sx={{ flex: 1 }}
          value={soyad}
          onChange={(e) => setSoyad(e.target.value)}
        />
      </Box>
      <Box
        sx={{ display: "flex", flexDirection: "row", gap: 2, width: "100%" }}
      >
        <TextField
          label="Kullanıcı Adı"
          variant="outlined"
          sx={{ flex: 1 }}
          value={kullaniciAdi}
          onChange={(e) => setKullaniciAdi(e.target.value)}
        />
        <TextField
          label="Şifre"
          type={showPassword ? "text" : "password"}
          variant="outlined"
          sx={{ flex: 1 }}
          value={sifre}
          onChange={(e) => setSifre(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box >
      <Box   sx={{ display: "flex", flexDirection: "row", gap: 2, width: "100%" }}  >
      <FormControl variant="outlined" sx={{ width: "100%" }}>
        <InputLabel id="rol-label">Kullanıcı Rolü</InputLabel>
        <Select
          labelId="rol-label"
          value={kullaniciRol}
          onChange={(e) => setKullaniciRol(e.target.value)}
          label="Kullanıcı Rolü"
        >
          <MenuItem value={1}>Eğitimci</MenuItem>
          <MenuItem value={2}>Kursiyer</MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="outlined" sx={{ width: "100%" }}>
        <InputLabel id="aktiflik-label">Aktiflik Durumu</InputLabel>
        <Select
          labelId="aktiflik-label"
          value={aktifDurum}
          onChange={(e) => setAktifDurum(e.target.value)}
          label="Aktiflik Durumu"
        >
          <MenuItem value={1}>Aktif</MenuItem>
          <MenuItem value={0}>Pasif</MenuItem>
        </Select>
      </FormControl>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          sx={{
            width: "50%",
            backgroundColor: "#1976d2",
            color: "white",
            borderRadius: '10px',
            "&:hover": {
              backgroundColor: "#115293",
              transform: 'scale(1.001)',
            },
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "İŞLEMİ TAMAMLA"} {/* Show loading indicator */}
        </Button>
      </Box>
      {error && <Typography color="error">{error}</Typography>}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default  KullaniciTanimla;